import { render } from "./customButton.vue?vue&type=template&id=c163e764&scoped=true"
import script from "./customButton.vue?vue&type=script&lang=js"
export * from "./customButton.vue?vue&type=script&lang=js"

import "./customButton.vue?vue&type=style&index=0&id=c163e764&lang=scss&scoped=true"

import exportComponent from "/home/dmytro/Projects/gcs/frontend/homepage/gc-schoenbuch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c163e764"]])

export default __exports__